import type { CityConfig } from "@/pages/city-template/types";

export const commackConfig: CityConfig = {
  city: "Commack",
  state: "New York",
  stateAbbr: "NY",
  slug: "commack",
  route: "/cities/commack",
  title: "Emergency & Expedited Passport Commack NY | Suffolk County",
  metaDescription:
    "Emergency passport Commack NY — same day, 24-hour, and 3-5 day expedited passport processing for Central Suffolk County. Fast Passport Center serves Smithtown, Hauppauge, Dix Hills, and all Commack communities.",
  h1: "Emergency & Expedited Passport Services in Commack, NY",
  heroSubtitle:
    "Commack's fast passport solution — Central Suffolk County. Whether you're flying out of JFK, LaGuardia, or Long Island MacArthur, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Beautiful%20Commack%20New%20York%20suburban%20neighborhood%20at%20golden%20hour%2C%20tree-lined%20streets%20with%20well-maintained%20homes%2C%20lush%20green%20lawns%2C%20Central%20Suffolk%20County%20charm%2C%20Long%20Island%20suburban%20community%2C%20warm%20afternoon%20sunlight%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20peaceful%20residential%20scene%20with%20mature%20trees%20and%20blue%20sky&width=1600&height=700&seq=ny-commack-hero-001&orientation=landscape",
  heroImageAlt: "Commack New York suburban neighborhood with tree-lined streets and well-maintained homes at golden hour",
  geoPosition: "40.8429; -73.2929",
  geoPlacename: "Commack, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~30 miles (via Long Island Expressway or LIRR)",
  },
  nearbyCitiesZips: [
    { name: "Smithtown", zips: "11745, 11754, 11780, 11787, 11788" },
    { name: "Hauppauge", zips: "11749, 11760, 11788" },
    { name: "Dix Hills", zips: "11746" },
    { name: "Kings Park", zips: "11754" },
    { name: "Northport", zips: "11768" },
    { name: "East Northport", zips: "11731" },
    { name: "Greenlawn", zips: "11740" },
    { name: "Huntington", zips: "11743, 11721, 11740, 11746, 11747, 11750" },
    { name: "Huntington Station", zips: "11746, 11750" },
    { name: "Halesite", zips: "11743" },
    { name: "Centerport", zips: "11721" },
    { name: "Cold Spring Harbor", zips: "11724" },
    { name: "Lloyd Harbor", zips: "11743" },
    { name: "Fort Salonga", zips: "11768" },
    { name: "Islip", zips: "11751, 11752" },
    { name: "Bay Shore", zips: "11706, 11769" },
    { name: "Brentwood", zips: "11717" },
    { name: "Central Islip", zips: "11722" },
    { name: "Deer Park", zips: "11729" },
    { name: "West Babylon", zips: "11704, 11707" },
    { name: "North Babylon", zips: "11703" },
    { name: "Melville", zips: "11747, 11775" },
    { name: "Plainview", zips: "11803" },
    { name: "Bethpage", zips: "11714" },
    { name: "Syosset", zips: "11773, 11791" },
    { name: "Jericho", zips: "11753" },
    { name: "Woodbury", zips: "11797" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
    { name: "Long Island", zips: "11001-11980" },
    { name: "Brooklyn", zips: "11201-11256" },
    { name: "Queens", zips: "11001-11697" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Commack travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Commack residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Central Suffolk County",
      desc: "Smithtown, Hauppauge, Dix Hills, and all Central Suffolk communities — we serve all of Commack's surrounding areas.",
    },
  ],
  testimonials: [
    {
      name: "Stephanie M.",
      location: "Commack, NY",
      rating: 5,
      text: "Needed my passport renewed for a business trip to Tokyo in 6 days. Fast Passport Center got it done in 5 days. The agent was incredibly helpful and even recommended the best photo spot near the Commack shopping center.",
      service: "Passport Renewal",
    },
    {
      name: "Daniel L.",
      location: "Dix Hills, NY",
      rating: 5,
      text: "First-time passport for our family vacation to Italy. The team walked us through everything and made the acceptance clerk visit at the Hauppauge post office a breeze. Passport arrived in 4 days.",
      service: "New Passport",
    },
    {
      name: "Rachel P.",
      location: "Smithtown, NY",
      rating: 5,
      text: "Lost my passport two weeks before my honeymoon. Fast Passport Center handled the DS-64 and DS-11 forms, got me to the Huntington post office for the clerk visit, and my replacement arrived in 3 days.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "commack-1",
      name: "Commack Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "2188 Jericho Turnpike",
      city: "Commack",
      state: "NY",
      zip: "11725",
      phone: "631-499-2335",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "In Commack",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Central Suffolk County passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "commack-2",
      name: "Hauppauge Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "60 Wireless Boulevard",
      city: "Hauppauge",
      state: "NY",
      zip: "11788",
      phone: "631-265-0867",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "~5 miles from Commack",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Convenient for Hauppauge, Commack, and Smithtown residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "commack-3",
      name: "Huntington Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "126 East Main Street",
      city: "Huntington",
      state: "NY",
      zip: "11743",
      phone: "631-423-1964",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "~8 miles from Commack",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Huntington, Northport, Commack, and North Shore Suffolk County communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Commack?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Commack residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility near Commack?",
      a: "The Commack Post Office at 2188 Jericho Turnpike is the closest facility in town. The Hauppauge Post Office at 60 Wireless Boulevard is approximately 5 miles away, and the Huntington Post Office at 126 East Main Street is about 8 miles away. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Commack?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Commack, Hauppauge, Dix Hills, and Smithtown. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Commack?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Commack passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. Commack residents can simply ship documents via overnight courier. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Commack?",
      a: "The fastest way to renew a passport in Commack is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Commack?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Commack and all of Central Suffolk County. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Commack?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Commack. We serve Central Suffolk County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Commack", address: "various CVS locations in Commack, Hauppauge, and Dix Hills", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Commack", address: "various Walgreens locations throughout Central Suffolk County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Commack", address: "various UPS Store locations in Commack and Hauppauge", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Commack", address: "various FedEx Office locations in Central Suffolk County", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Hauppauge",
      address: "2500 Nesconset Highway, Hauppauge, NY 11788",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Major Suffolk County DMV office serving Central Suffolk including Commack, Hauppauge, Smithtown, and Dix Hills. Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Huntington",
      address: "200 East Main Street, Huntington, NY 11743",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Suffolk County DMV office serving North Shore communities. Alternative option for Commack residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Medford",
      address: "2699 Route 112, Medford, NY 11763",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Suffolk County DMV office serving South Shore communities. Alternative option for Commack residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~35 miles from Commack",
      address: "JFK Access Road, Jamaica, NY 11430",
      note: "Major international gateway with direct flights to Europe, Asia, and worldwide destinations. Accessible via Long Island Expressway from Commack.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: true,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~30 miles from Commack",
      address: "Ditmars Boulevard, Flushing, NY 11369",
      note: "Domestic-focused airport with flights to major U.S. cities. Accessible via Northern State Parkway from Commack.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LaGuardia Airport",
      featured: true,
    },
    {
      code: "ISP",
      name: "Long Island MacArthur Airport",
      distance: "~20 miles from Commack",
      address: "100 Arrival Avenue, Ronkonkoma, NY 11779",
      note: "Long Island's own airport with flights to Florida, the Caribbean, and major U.S. hubs. Very convenient for Central Suffolk County travelers.",
      flightUrl: "https://www.macarthurairport.com/",
      flightLabel: "MacArthur Airport",
      featured: true,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Commack travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Commack residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Commack residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Commack residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Commack, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Commack residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Commack travelers with immediate departure needs from JFK, LaGuardia, or Long Island MacArthur Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for Commack residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Commack residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Commack residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Commack and Central Suffolk County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Commack." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Commack travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Commack travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Commack team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier from Commack to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Commack address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: ["Mail-in application", "No expedited handling", "No dedicated agent", "No phone or email contact for your case", "Updates only by physical mail letter"],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: ["Secure overnight shipping included", "Document review before submission", "Dedicated agent assigned", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: ["Secure overnight shipping included", "Document review before submission", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: ["For documented life-or-death emergencies only", "Requires proof of emergency travel", "Strictly for documented life-or-death emergencies"],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Long Island", route: "/cities/long-island" },
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Huntington", route: "/cities/huntington" },
    { name: "Hicksville", route: "/cities/hicksville" },
    { name: "Bay Shore", route: "/cities/bay-shore" },
    { name: "Islip", route: "/cities/islip" },
    { name: "West Babylon", route: "/cities/west-babylon" },
    { name: "Smithtown", route: "/cities/smithtown" },
    { name: "Levittown", route: "/cities/levittown" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "White Plains", route: "/cities/white-plains" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Commack and all of Central Suffolk County as a remote courier service. We do not have a physical office in Commack, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Commack area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Commack and all of Central Suffolk County. From Smithtown to Hauppauge, from Dix Hills to Kings Park — we serve all of the Commack area with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Commack and all surrounding communities across Central Suffolk County. Whether you're in Smithtown, Hauppauge, Dix Hills, or Northport, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Commack customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Commack travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Commack and Central Suffolk County travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Commack. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default commackConfig;